import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, PhoneIcon } from 'lucide-react';
import { clinic } from '../data/clinic';
const points = ['Vergoed vanuit de basisverzekering', 'Intake binnen één tot vier weken', 'Verwijzing van huisarts of specialist'];
export function AppointmentAside() {
  return <aside className="rounded-3xl border border-line bg-white p-7 lg:sticky lg:top-32" data-id="element-50" data-mp="18etbe8y1qhyr">
      <h2 className="font-display text-xl font-semibold text-ink" data-id="element-51" data-mp="tqqahdyv1wgt">Contact</h2>
      <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-52" data-mp="yhgeonvjvt9x">
        Heeft u een vraag of wilt u weten of onze behandelingen geschikt zijn voor uw situatie? Wij helpen u graag.
      </p>
      <ul className="mt-5 space-y-2.5" data-id="element-53" data-mp="pp4z5x1z5q8q">
        {points.map(point => <li key={point} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-54" data-mp="pnaemjum8056">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-55" data-mp="asw0oxpwrgxd" />
            {point}
          </li>)}
      </ul>
      <div className="mt-7 flex flex-col gap-2.5" data-id="element-56" data-mp="2jd4bgd77guwn">
        <a href={clinic.phoneHref} className="flex items-center justify-center gap-2 rounded-full bg-primary py-3 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-primary-dark" data-id="element-57" data-mp="2jbsybmrveasv">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="2od05bjm6v5yh" />
          {clinic.phone}
        </a>
        <Link to="/contact" className="rounded-full border border-line py-3 text-center text-[15px] font-semibold text-ink transition-colors duration-150 hover:border-primary/40 hover:text-primary" data-id="element-59" data-mp="20mwe6bq6syod">
          Stuur een bericht
        </Link>
      </div>
      <p className="mt-5 text-xs text-muted" data-id="element-60" data-mp="29hasaayze35w">{clinic.hours}</p>
    </aside>;
}